import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Modal, Form, InputGroup, FormControl, Alert, Pagination } from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import { getDepartments, deleteDepartment } from '../services/departmentService';
import DepartmentForm from './DepartmentForm';
import Layout from './Layout';
import TopBar from './TopBar';
const DepartmentsList = () => {
  const [departments, setDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchDepartments();
  }, [currentPage, searchTerm]);

  const fetchDepartments = async () => {
    try {
      const response = await getDepartments({
        name: searchTerm,
        page: currentPage,
        per_page: 10
      });
      setDepartments(response.data);
      setTotalPages(response.last_page);
    } catch (error) {
      setAlertMessage('Failed to fetch departments');
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this department?')) {
      try {
        await deleteDepartment(id);
        setAlertMessage('Department deleted successfully');
        setAlertVariant('success');
        setShowAlert(true);
        fetchDepartments();
      } catch (error) {
        setAlertMessage('Failed to delete department');
        setAlertVariant('danger');
        setShowAlert(true);
      }
    }
  };

  const handleEdit = (department) => {
    setEditingDepartment(department);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingDepartment(null);
  };

  const handleFormSubmit = () => {
    handleFormClose();
    fetchDepartments();
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const renderPagination = () => {
    const items = [];
    for (let i = 1; i <= totalPages; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={currentPage === i}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
    return items;
  };

  return (
    <Layout>
         <TopBar >  
        
        <Form className="d-none d-md-flex" style={{ width: '250px' }}>
           <FormControl
             type="search"
             placeholder="Search"
             aria-label="Search"
             value={searchTerm}
             onChange={(e) => setSearchTerm(e.target.value)}
             className="me-2"
           />
         </Form>
     </TopBar>
            
        
    <Container fluid>
  

      <Row className="mt-3">
        <Col className="text-end">
          <Button
            variant="primary"
            onClick={() => {
              setEditingDepartment(null);
              setShowForm(true);
            }}
          >
            Add Department
          </Button>
        </Col>
      </Row>

      {showForm && (
        <DepartmentForm
          onClose={handleFormClose}
          department={editingDepartment}
          onSubmit={() => {
            handleFormClose();
            fetchDepartments();
          }}
        />
      )}

      <Row className="mt-4">
        <Col>
          <Table hover responsive>
            <thead>
              <tr>
                <th>Name</th>
             
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {departments.map((department) => (
                <tr key={department.id}>
                  <td>{department.name}</td>
                 
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleEdit(department)}
                      className="me-2"
                    >
                      <FaPen className="me-1" /> Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(department.id)}
                    >
                      <FaTrash className="me-1" /> Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      {totalPages > 1 && (
        <Row className="mt-3">
          <Col className="text-center">
            <Pagination>
              {renderPagination()}
            </Pagination>
          </Col>
        </Row>
      )}

      {showAlert && (
        <Row className="mt-3">
          <Col>
            <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          </Col>
        </Row>
      )}
    </Container>
    </Layout>
  );
};

export default DepartmentsList;